module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 2.a7196395.png";